function getConsignmentStatusIdByRouteName (routeName) {
  switch (routeName) {
    case 'ConsignmentListItem': return 1
    case 'ReadyConsignmentList': return 2
    case 'ShippingConsignmentList': return 3
    case 'ArchiveConsignmentList': return 4
    case 'QueueConsignmentList': return 0
  }
}

function getConsignmentRouteNameByStatusId (routeId) {
  switch (routeId) {
    case 0: return 'QueueConsignmentList'
    case 1: return 'ConsignmentListItem'
    case 2: return 'ReadyConsignmentList'
    case 3: return 'ShippingConsignmentList'
    case 4: return 'ArchiveConsignmentList'
    default: return null
  }
}

export {
  getConsignmentStatusIdByRouteName,
  getConsignmentRouteNameByStatusId
}
